<template>
    <div>
        <h1>{{ $t('login_title') }}</h1>
        <form v-on:submit="login">
            <label>
                {{ $t('login_username') }}
                <input v-model="form.username">
            </label>
            <label>
                {{ $t('login_password') }}
                <input v-model="form.password" type="password">
            </label>
            <input type="submit" :value="$t('login_login')">
        </form>
    </div>
</template>

<script>
    import {bus} from '../main'
    import Store from '../store'
    import config from '../config'
    export default {
        name: 'login',
        components: {
        },
        data:function(){
            return {
                form:{username: '' , password: ''},
            }
        },
        methods:{
            login() {
                this.axios.post(config.API_URL+'users/login',new URLSearchParams({
                    username: this.form.username,
                    password: this.form.password,
                }).toString()).then(response => {
                    response.data;
                    bus.$emit('login',true);
                    Store.commit('setAuthenticated',true);

                    this.$router.replace({ name: "domain_list" });
                }).catch(error => {
                    bus.$emit('alert-error',error.response.data.message);
                });
            },
        },
    }
</script>

<style scoped>
</style>
